import React from 'react';
import {connect} from 'react-redux';
import {goToPage, setSubscriber} from '../../ServiceAppointmentBlockSlice';
import {goToNextPageAsync} from '../../ServiceAppointmentAsyncthunk';
import Subscribers from '../../../../Shared/GeneralPages/Subscribers/Subscribers';

const SubscriberPage = (props) => {
  return <Subscribers saleType={'internet'} onSelectSubscriber={handleOnSelectSubscriber} selectedSubscriber={props.productSubscriberNo} />;

  function handleOnSelectSubscriber(subscriber) {
    if (subscriber) {
      props.setSubscriber(subscriber);
    }
    props.goToNextPageAsync();
  }
};

const mapStateToProps = (state) => {
  return {
    productSubscriberNo: state.selfcarePage?.isFetchData ? state.selfcarePage?.selectedSubscriber?.subscriberNumber : '',
  };
};

const mapDispatchToProps = {
  goToPage,
  setSubscriber,
  goToNextPageAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberPage);
